export default "__VITE_ASSET__CME1gAZR__"